const STORAGE_KEY = 'nefro-product-recommendation-attribution';
const ATTRIBUTION_TTL_MS = 30 * 60 * 1000;

const pushEvent = payload => {
    if (typeof window === 'undefined')
        return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
};

const eventItem = item => ({
    source_product_id: item.source_product_id,
    source_variant_id: item.source_variant_id,
    product_id: item.product_id,
    variant_id: item.variant_id,
    recommendation_position: item.rank,
    recommendation_reason: item.reason
});

export const trackRecommendationImpression = ({
    sourceProductId,
    sourceVariantId,
    items
}) => {
    pushEvent({
        event: 'recommendation_impression',
        source_product_id: sourceProductId,
        source_variant_id: sourceVariantId,
        recommendations: items.map(item => eventItem({
            ...item,
            source_product_id: sourceProductId,
            source_variant_id: sourceVariantId
        }))
    });
};

export const trackRecommendationClick = ({
    sourceProductId,
    sourceVariantId,
    item,
    now = Date.now()
}) => {
    const attribution = {
        ...eventItem({
            ...item,
            source_product_id: sourceProductId,
            source_variant_id: sourceVariantId
        }),
        created_at: now
    };
    pushEvent({
        event: 'recommendation_click',
        ...attribution
    });
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
    } catch (error) {
        // La navegación continúa aunque el navegador no permita sessionStorage.
    }
};

export const trackRecommendationAddToCart = ({
    productId,
    variantId,
    now = Date.now()
}) => {
    let attribution;
    try {
        attribution = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (error) {
        attribution = null;
    }
    if (!attribution)
        return false;

    const expired = now - Number(attribution.created_at || 0) > ATTRIBUTION_TTL_MS;
    const matches = String(attribution.product_id) === String(productId) &&
        String(attribution.variant_id) === String(variantId);
    if (expired || matches) {
        try {
            sessionStorage.removeItem(STORAGE_KEY);
        } catch (error) {
            // No se interrumpe la acción de carrito.
        }
    }
    if (expired || !matches)
        return false;

    pushEvent({
        event: 'recommendation_add_to_cart',
        ...attribution
    });
    return true;
};

export const RECOMMENDATION_ATTRIBUTION_TTL_MS = ATTRIBUTION_TTL_MS;
export const RECOMMENDATION_STORAGE_KEY = STORAGE_KEY;
